import {
	ChangeDetectionStrategy, ChangeDetectorRef,
	Component,
	Inject,
	OnDestroy,
	OnInit
} from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { FormService } from "../../services/form.service";
import { MatCalendar } from "@angular/material/datepicker";
import { Subject, takeUntil } from "rxjs";
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from "@angular/material/core";
import { DatePipe } from '@angular/common';

@Component( {
	selector: 'app-moving-date',
	templateUrl: './moving-date.component.html',
	styleUrls: ['./moving-date.component.scss'],
	// changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class MovingDateComponent implements OnInit {

	movingDate!: UntypedFormGroup
	startDate!: Date;
	formGroupName: string = 'movingDate'
	public selectedDate!: Date;
	customDatePickerHeader = customDatePickerHeader;
	public showRequiredError: boolean = false;

	constructor( public formService: FormService,
	             public datePipe: DatePipe ) {
	}

	ngOnInit(): void {

		this.startDate = new Date();
		this.movingDate = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
	}

	onSelect( selectedDate: Date ) {

		// Hide any previous errors
		this.showRequiredError = false;

		// Save selection
		this.selectedDate = selectedDate;

		var dateInCorrectFormat = this.datePipe.transform( selectedDate, 'yyyy-MM-dd' );
		(<UntypedFormGroup>this.movingDate).controls['movingDate'].setValue( dateInCorrectFormat );

		// Check if 9 months in future
		var dateCheck = new Date();
		var monthsTooFar = 9;
		dateCheck.setMonth( dateCheck.getMonth() + monthsTooFar );

		// If selected date is past the dateCheck
		if( this.selectedDate > dateCheck ) {

			this.formService.showNote = true;
		}
		else {

			this.formService.showNote = false;
		}
	}

	ngAfterViewInit() {

		// After view has loaded
	}

	public onSubmit() {

		if( this.movingDate.controls['movingDate'].value.length === 0 ) {

			// This gets on false within onSelect()
			this.showRequiredError = true;
		}

		this.formService.showNote = false;
		this.formService.submitFormGroup( (<UntypedFormGroup>this.movingDate) );
	}
}

/** Custom header component for datepicker. */
@Component( {
	selector: 'custom-datepicker-header',
	styles: [`
		.custom-datepicker-header {
			display: flex;
			align-items: center;
			padding: 0.5em;
			justify-content: center;
			
			button {
				
				color: #FF5F2D;
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				align-items: center;

				// Prevent double tap zoom for IOS
				touch-action: manipulation;
			}
		}

		.custom-datepicker-header-label {
			font-size: 20px;
			text-align: center;
			padding: 0 5px;
			color: #000083;
		}
	`],
	template: `
		<div class='custom-datepicker-header'>
			<button mat-icon-button type='button'
			        (click)="previousClicked('month')">
				<svg xmlns='http://www.w3.org/2000/svg'
				     width='16'
				     height='16'
				     fill='currentColor'
				     class='bi bi-chevron-left'
				     viewBox='0 0 16 16'>
					<path fill-rule='evenodd'
					      d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/>
				</svg>
			</button>
			<span class='custom-datepicker-header-label'>{{periodLabel}}</span>
			<button mat-icon-button type='button'
			        (click)="nextClicked('month')">
				<svg xmlns='http://www.w3.org/2000/svg'
				     width='16'
				     height='16'
				     fill='currentColor'
				     class='bi bi-chevron-right'
				     viewBox='0 0 16 16'>
					<path fill-rule='evenodd'
					      d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/>
				</svg>
			</button>
			
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class customDatePickerHeader<D> implements OnDestroy {
	private _destroyed = new Subject<void>();

	constructor( private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>,
		@Inject( MAT_DATE_FORMATS ) private _dateFormats: MatDateFormats, cdr: ChangeDetectorRef, private formService: FormService ) {

		_calendar.stateChanges
			.pipe( takeUntil( this._destroyed ) )
			.subscribe( () => cdr.markForCheck() );
	}

	ngOnDestroy() {
		this._destroyed.next();
		this._destroyed.complete();
	}

	get periodLabel() {

		return this._dateAdapter
			.format( this._calendar.activeDate, this._dateFormats.display.monthYearA11yLabel );
	}

	onAction() {

		var currentDate = new Date( this._dateAdapter.toIso8601( this._calendar.activeDate ) );
		var todayDate = new Date();
		var todayPlus10MonthsDate = new Date( todayDate.setMonth(todayDate.getMonth() + 10 ) );

		// Get month amount difference between 2 dates
		var difference = todayPlus10MonthsDate.getMonth() - currentDate.getMonth() +
			(12 * (todayPlus10MonthsDate.getFullYear() - currentDate.getFullYear()))

		// If the difference between the shown date and today+10Months = less than 1
		// Then show date too far message
		if( difference < 1 ) {

			this.formService.showNote = true;
		}
		// Not enough difference
		else if( this.formService.showNote ) {

			// Check if there is no selection yet.
			// We don't want to clear the note when the user selected a date in the 9th month
			if( (<UntypedFormGroup>this.formService.mainForm.get( 'movingDate' ) ).controls['movingDate'].value.length === 0 ) {

				this.formService.showNote = false;
			}
		}
	}

	// Option to switch a whole year
	previousClicked( mode: 'month' | 'year' ) {
		this._calendar.activeDate = mode === 'month' ?
			this._dateAdapter.addCalendarMonths( this._calendar.activeDate, -1 ) :
			this._dateAdapter.addCalendarYears( this._calendar.activeDate, -1 );

		this.onAction();
	}

	nextClicked( mode: 'month' | 'year' ) {

		this._calendar.activeDate = mode === 'month' ?
			this._dateAdapter.addCalendarMonths( this._calendar.activeDate, 1 ) :
			this._dateAdapter.addCalendarYears( this._calendar.activeDate, 1 );

		this.onAction();
	}
}